import { all, call, put, takeLatest } from "redux-saga/effects"
import * as types from "./actionTypes"
import * as actions from "./actions"
import {
  apiBuscarGruposDrePlanoContas,
  apiBuscarPlanoContasPorEmpresa,
  apiSalvarPlanoContasLote,
} from "../../helpers/backend_helper"

function* buscarCadastro({ payload }) {
  try {
    const [cadastro, dre] = yield all([
      call(apiBuscarPlanoContasPorEmpresa, payload.empresa),
      call(apiBuscarGruposDrePlanoContas, payload.empresa),
    ])
    yield put(actions.buscarPlanoContasCadastroSucesso(cadastro?.contas || [], dre?.grupos || []))
  } catch (error) {
    yield put(actions.buscarPlanoContasCadastroFalha("planocontas.erro.carregar"))
  }
}

// 409 = contas com lançamentos aguardando confirmação; 422 = validação por linha
function* salvarLote({ payload }) {
  try {
    const resposta = yield call(apiSalvarPlanoContasLote, payload)
    yield put(actions.salvarPlanoContasLoteSucesso(resposta?.contas || []))
  } catch (error) {
    const status = error?.response?.status
    const dados = error?.response?.data || {}
    if (status === 409 && Array.isArray(dados.impactos)) {
      yield put(actions.salvarPlanoContasLoteImpactos(dados.impactos))
    } else if (status === 422 && Array.isArray(dados.erros)) {
      yield put(actions.salvarPlanoContasLoteErros(dados.erros))
    } else {
      yield put(actions.salvarPlanoContasLoteFalha("planocontas.erro.salvar"))
    }
  }
}

export default function* PlanoContasSaga() {
  yield all([
    takeLatest(types.BUSCAR_PLANO_CONTAS_CADASTRO, buscarCadastro),
    takeLatest(types.SALVAR_PLANO_CONTAS_LOTE, salvarLote),
  ])
}
